import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import MobileStickyCTA from "@/components/layout/MobileStickyCTA";
import FloatingWhatsApp from "@/components/layout/FloatingWhatsApp";
import FloatingCall from "@/components/layout/FloatingCall";
import GlobalEnquiry from "@/components/GlobalEnquiry";
import LeadPopup from "@/components/LeadPopup";
import ChatWidget from "@/components/ChatWidget";
import { Toaster } from "sonner";

export default function Layout({ children }) {
  const loc = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  const hideChrome = loc.pathname.startsWith("/admin");

  return (
    <div className="App min-h-screen">
      {!hideChrome && <Navbar />}
      <main className={hideChrome ? "" : "pt-16 md:pt-20"}>
        {children}
      </main>
      {!hideChrome && (
        <>
          <GlobalEnquiry />
          <Footer />
          <MobileStickyCTA />
          <FloatingCall />
          <FloatingWhatsApp />
          <LeadPopup />
          <ChatWidget />
        </>
      )}
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "var(--pcv-surface-2)", color: "var(--pcv-text)", border: "1px solid var(--pcv-border)" } }} />
    </div>
  );
}
